import React from 'react'

export const Partenaire = () => {
    return (
        <div>Partenaire</div>
    )
}
